<template>
  <div>
    <loading-spinner v-if="isLoading"></loading-spinner>
    <div class="large-panel pt-3" v-if="notLoadingOnInvoiceSubmissionPreviewPage">
      <span class="main-title">Invoice submission</span>

      <back-to-home-page-button />

      <form-validation-errors v-if="activeTabIndex < 1" />

      <div class="row no-gutters">

        <div class="col-12 mt-2 p-4 form-outline col-print-12">
          <div class="justify-content-end">
            <button class="close close-btn" @click="navigateToHome()" :disabled="isLoading">
              <font-awesome-icon icon="times" />
            </button>
          </div>

          <alert-message class="px-md-5 px-0 my-3" v-if="errorMessage"></alert-message>

          <form-header :current-tab="currentTab" :tab-items="tabItems" :current-user="currentUser" />

          <component class="px-md-5 px-0"
                     :is="currentComponent"
                     :formData="'invoiceSubmissionData'"
                     @setCurrentTab="setCurrentTab"
                     :backNav="tabItems[0].component"
                     :nextNav="tabItems[1].component" />
        </div>
      </div>
      <div class="row d-block pl-3 pt-4 font-italic">
        <div v-html="FORM_LABELS.INVOICE_WEBFORM_FOOTER" />
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex"
import InvoiceSubmissionQuestionnaire from "@/components/Payments/InvoiceSubmission/InvoiceSubmissionQuestionnaire";
import LoadingSpinner from "@/components/LoadingSpinner";
import Support from "@/components/Support";
import AlertMessage from "@/components/AlertMessage";
import PreviewInvoiceSubmission from "@/components/Payments/InvoiceSubmission/PreviewInvoiceSubmission";
import PaymentFormsMixin from "@/mixins/PaymentFormsMixin";
import BackToHomePageButton from "@/components/Payments/BackToHomePageButton";
import FormValidationErrors from "@/components/Payments/FormValidationErrors";
import FORM_LABELS from "@/store/FormLabels";
import FormHeader from "@/components/Payments/FormHeader";

export default {
  name: "InvoiceSubmission",
  mixins: [PaymentFormsMixin],
  components: {
    FormValidationErrors,
    BackToHomePageButton,
    LoadingSpinner,
    InvoiceSubmissionQuestionnaire,
    Support,
    AlertMessage,
    PreviewInvoiceSubmission,
    FormHeader
  },
  computed: {
    ...mapGetters(["isLoading","currentUser","errorMessage",'formValidationErrors']),
    notLoadingOnInvoiceSubmissionPreviewPage() {
      return this.activeTabIndex == 1 ? true : !this.isLoading
    }
  },
  watch: {
    currentTab(val) {
      this.currentComponent = val
      this.activeTabIndex = this.tabItems.findIndex(tab => tab.component === val)
    }
  },
  data(){
    return{
      activeTabIndex: 0,
      currentComponent: '',
      tabItems: [
        {
          name: FORM_LABELS.INVOICE_SUBMISSION_FORM_TITLE,
          component: "InvoiceSubmissionQuestionnaire",
          subDesc: FORM_LABELS.SUBMIT_AN_INVOICE_DESC
        },
        {
          name: "Preview Invoice submission",
          component: "PreviewInvoiceSubmission",
        }
      ],
      currentTab: ""
    }
  },
  created: function () {
    this.initializeInvoiceSubmission()
  },
  beforeDestroy() {
    this.clearAllFormsData()
    this.resetInvoiceSubmissionData()
  },
  methods:{
    ...mapActions(["clearAllFormsData"]),
    async initializeInvoiceSubmission(){
      this.currentComponent = this.tabItems[0].component
      this.currentTab = this.tabItems[0].component
      await this.getAllRequiredData()
    },
    onNavItemClicked(index) {
      this.activeTabIndex = index
      this.currentComponent = this.tabItems[index].component
    },
    setCurrentTab(tab) {
      window.scrollTo(0,0)
      this.currentComponent = this.tabItems.find(item => item.component === tab).component
      this.currentTab = this.tabItems.find(item => item.component === tab).component
    }
  }

}
</script>

<style scoped>
.large-panel {
  padding-bottom: 30px;
  margin: 0px 0px 15px 0px;
  min-height: 350px;
}

@media (max-width: 1000px) {
  .nav-tabs li {
    width: 100%;
  }
}

.nav-tabs,
.nav-link {
  border: none;
  border-radius: 0;
  border: 0 !important;
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  border-color:inherit;
}
.nav-tabs li a.active {
  color: #0696d7;
  font-weight: bold;
  border-bottom: 4px #0696d7 solid !important;
}
.navitem-active {
  color: #0696d7 !important;
  font-weight: bold !important;
  border-bottom: 2px #0696d7 solid !important;
  padding: 1px;
}
.nav-tabs{
  border:none;
}
.nav-tabs{
  border:none;
}
.nav-tabs li a {
  min-width: 100px;
  height: 75px;
  padding-top: 25px;
  text-align: center;
  color: #000;
  font-size: 14px;
}
</style>

<style>
.section-complete {
  color: #87bc40 !important;
}

.form-outline {
  border: 1px solid #ced4da
}


</style>